import axios from "axios";

const baseURL = "https://api.coinpaprika.com/v1";

// Global Market overview information
export const globalMarketOverview = () => axios.get(`${baseURL}/global`);

//Coin All Coins Basic Information
export const getCoins = () => axios.get(`${baseURL}/coins`);

// Coin Details
export const getCoinDetails = (id) => axios.get(`${baseURL}/coins/${id}`);

// Coin Price Tickers
export const getCoinTickers = (id) => axios.get(`${baseURL}/tickers/${id}`);

// Get historical ticks
export const getHistoricalTicks = (id, interval, start) =>
  axios.get(
    `${baseURL}/tickers/${id}/historical?interval=${interval}&start=${start}`
  );
